import { Injectable } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SnackbarService } from '@shared/service/snackbar/snackbar.service';
import { map } from 'rxjs/operators';

import * as applicationSelectors from './application.actions';

@Injectable()
export class ApplicationEffects {
  genericError = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          applicationSelectors.genericErrorAction,
          applicationSelectors.applicationActions.genericError
        ),
        map((payload: { message?: string }) => {
          this.snackbarService.error(
            payload.message
              ? payload.message
              : this.translocoService.translate('genericErrorMessage')
          );
        })
      ),
    { dispatch: false }
  );

  genericSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(applicationSelectors.applicationActions.genericSuccess),
        map((payload: { message: string }) => {
          this.snackbarService.success(payload.message);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly snackbarService: SnackbarService,
    private readonly translocoService: TranslocoService
  ) {}
}
